"use client";

import React from "react";
import { Clock } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const pricingOptions = [{
  id: "30m",
  duration: "30 minutes",
  price: "£30"
}, {
  id: "45m",
  duration: "45 minutes",
  price: "£45"
}, {
  id: "60m",
  duration: "60 minutes",
  price: "£60"
}];
export default function MassagePricing() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="sportsmassagepricing" data-nav="light" className="bg-background py-16 sm:py-20 md:py-24">
      <div className="container mx-auto max-w-3xl px-4 sm:px-6">
        <div className="text-center">
          <h2 className="font-display text-3xl font-bold tracking-wide text-primary sm:text-4xl">
            Sports massage
          </h2>
          <div className="mx-auto mt-4 h-1 w-12 rounded-full bg-accent" />
        </div>

        <div className="mt-10 sm:mt-12 flex flex-col gap-4">
          {pricingOptions.map((option, i) => <motion.div key={option.id} data-index={i} initial={shouldReduceMotion ? {
          opacity: 1
        } : {
          opacity: 0,
          y: 16
        }} whileInView={shouldReduceMotion ? {
          opacity: 1
        } : {
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: shouldReduceMotion ? 0 : i * 0.1,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} className="card flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:justify-between sm:p-6">
              <div className="flex items-center gap-3">
                <div className="flex size-10 items-center justify-center rounded-md bg-secondary text-accent">
                  <Clock className="size-5 text-accent" />
                </div>
                <span className="font-display text-lg font-semibold text-primary sm:text-xl">
                  {option.duration}
                </span>
              </div>

              <div className="flex items-center justify-between gap-6 sm:justify-end">
                <span className="font-display text-2xl font-bold text-primary sm:text-3xl">
                  {option.price}
                </span>
                <Button asChild size="sm" className="bg-primary hover:bg-primary-hover text-primary-foreground">
                  <Link to="https://align-physiotherapy.uk3.cliniko.com/bookings?business_id=1869864670421067946&practitioner_id=1869864668449745369&appointment_type_id=1869864670219741836">Book</Link>
                </Button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}